import { Box } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';

import Loader from 'Component/loader';
import Layout from 'Component/layout';
import { Condition } from 'Component/others';
import checkPublicRoute from 'Helper/checkPublicRoute';
import hideNavbar from 'Helper/hideNavbar';
import hideHelpButton from 'Helper/hideHelpButton';
import Toast from 'UiKit/toast';
import CustomModal from 'UiKit/modal';
import { useAppSystem } from 'Store/app';
import { useUserInfo } from 'Store/userInfo';

import useGetHelpRequestStatus from 'Domain/host-help-partner/useGetHelpRequestStatus';
import useGetPresences from 'Domain/host-attendance-record/useGetPresences';
import HelpHost from 'Component/mobile-container/widget/help-host';
import BottomNavigationBar from 'Component/mobile-container/widget/bottom-navigation-bar';
import HelpButton from 'Component/mobile-container/widget/help-button';
import ConfirmDrawer from 'Component/mobile-container/widget/confirm-drawer';
import StatusState from 'Component/mobile-container/widget/status-state';
import LivestreamFloating from 'Component/mobile-container/widget/livestream-floating';

import styles from './styles.module.css';

const MobileContainer = ({ children }) => {
  const { pathname } = useLocation();
  const { organization } = useUserInfo();
  const isMalayOrg = organization?.region === 'MY';
  const isPublic = checkPublicRoute(pathname);

  const { isHideMobileNavBar, isHideHelpButton: isHideHelpButtonStore } = useAppSystem();

  const { data: dataStatusHelp, isLoading: isLoadingHelpStatus } = useGetHelpRequestStatus({ isPublic });
  const { data: presenceData } = useGetPresences({ isPublic });

  const isIdleHelpHost = dataStatusHelp?.status === 'IDLE';
  const isStreamPage = pathname === '/host/stream';

  const { isLivestreaming } = presenceData ?? {};

  const isHideNavBar = hideNavbar(pathname) || isHideMobileNavBar;
  const isHideHelpButton = hideHelpButton(pathname) || isHideHelpButtonStore || (isStreamPage && !isLivestreaming);

  const shouldShowHelpButton = isIdleHelpHost && !isMalayOrg;
  const shouldShowHelpHost = !isIdleHelpHost && !isStreamPage;
  const shouldShowLivestreamFloating = isLivestreaming && !isStreamPage && (isMalayOrg || isIdleHelpHost);

  return (
    <Box className={styles['mobile__container']}>
      <Layout children={children} />
      {/* Global component */}
      <StatusState />
      <ConfirmDrawer />
      <Toast />
      <CustomModal />
      <Loader />
      <Condition statement={!isHideHelpButton}>
        {/* Help Request & Livestream Status */}
        <Condition statement={!isLoadingHelpStatus}>
          <Box className={styles['widget__container']}>
            {/* Livestream Widget */}
            <Condition statement={shouldShowLivestreamFloating}>
              <LivestreamFloating isHideNavBar={isHideNavBar} />
            </Condition>
            {/* Help Button */}
            <Condition statement={shouldShowHelpButton}>
              <HelpButton isHideNavBar={isHideNavBar} isLivestreaming={isLivestreaming} />
            </Condition>
            {/* Help Host Widget Bar */}
            <Condition statement={shouldShowHelpHost}>
              <HelpHost isHideNavBar={isHideNavBar} dataStatusHelp={dataStatusHelp} isLivestreaming={isLivestreaming} />
            </Condition>
          </Box>
        </Condition>
      </Condition>
      <Condition statement={!isHideNavBar}>
        {/* Bottom Navigation Bar */}
        <BottomNavigationBar />
      </Condition>
    </Box>
  );
};

export default MobileContainer;
